import { IENVSamplesAndTests } from "../../models/ENVSamplesandTests";
import { IENVApplicationDetails } from "../../models/ENVApplicationDetails";
import { IChooseApp } from "../../models/ChooseApp";
import { IFilerInformation } from "../../models/FilerInformation";
import { IPersonalInfo } from "../../models/PersonalInfo";
import { IlabENVPreference } from "../../models/ENVPreference";

export interface IENVRequest {
  labENVChooseApplDetails: IChooseApp;
  labENVPersonalInfoDetails: IPersonalInfo;
  labENVFilerInfoDetails: IFilerInformation;
  labENVApplicationDetails: IENVApplicationDetails;
  labENVSampleTests: IENVSamplesAndTests[];
  labApplicationchangedDetails?: IENVApplicationDetails;
  labChangedPreference?: IlabENVPreference;
  labchangedSampleTestDetails?: IENVSamplesAndTests[];
  labENVPreference: IlabENVPreference;
  applicationNumber?: string;
  actionStatus?: string;
  submittedFeedback?: number;
  isReportGenerated?: number;
  reasonForCancellation?: string;
  labENVApplicationStatus?: IENVApplicationStatus;
  labReportDetails?: string;
}

export interface IENVApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  islabapplicationamended?: number;
  islabapplicationcancelled?: number;
  actionedStatus?: string;
  ActionRequest: string;
  amendmentRaisedStage?: number | null;
  islabapplicationDuplicated?: number;
}

export const defENVAmmendAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 18,
  eserviceApplication: 14,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};

export const defENVAmmendRowAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 30,
  eserviceApplication: 20,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defENVCancelAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
export const defENVAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defENVPostStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 1,
  eserviceApplication: 1,
  ActionRequest: "Application Submitted",
};

export const defENVExchangeAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defDuplicateAppStatus: IENVApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 31,
  eserviceApplication: 21,
  islabapplicationDuplicated: 1,
  ActionRequest: "Duplicate request",
};
